import React from "react";
import { SERVICES } from "../data/services";
import ServiceCard from "../components/ServiceCard";
import { Link } from "react-router-dom";

export default function Services() {
  return (
    <div className="pt-32 pb-24 bg-[#050505] min-h-screen" data-testid="services-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-14">
          <div className="label-eyebrow mb-3">Our Services</div>
          <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tight">
            Luxury transportation, every occasion.
          </h1>
          <p className="text-white/65 mt-5 leading-relaxed">
            From airport transfers and corporate travel to weddings, wine tours, and armed security
            transportation — discover the full range of USA Limo Service.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => <ServiceCard key={s.slug} service={s} index={i} />)}
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          <Link to="/executive-chauffeur" className="lux-card p-8 flex flex-col gap-3" data-testid="services-exec-link">
            <div className="label-eyebrow">Executive Chauffeur For Hire</div>
            <h3 className="font-display text-2xl text-white">We Drive Your Vehicle — You Relax</h3>
            <p className="text-white/65 text-sm">Hire a professional chauffeur to drive your own car. Discreet, convenient, executive-level service.</p>
          </Link>
          <Link to="/zuber-valet" className="lux-card p-8 flex flex-col gap-3" data-testid="services-zuber-link">
            <div className="label-eyebrow">Zuber Valet Service</div>
            <h3 className="font-display text-2xl text-white">Luxury Valet for Premium Events</h3>
            <p className="text-white/65 text-sm">Professional parking. First-class arrival. Reliable valet across the DMV.</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
